/* istanbul ignore file */
import { createAction, createReducer } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  setorListar: { list: [] },
  setorDetalhar: null,
};
export const duckTodosSetoresListar = createAction('DUCK_TODOS_SETORES_LISTAR');
export const duckSetorDetalhar = createAction('DUCK_SETORES_DETALHAR');

export default createReducer(INITIAL_STATE, {
  [duckTodosSetoresListar.type]: (state, action) => ({
    ...state,
    setorListar: action.payload,
  }),
  [duckSetorDetalhar.type]: (state, action) => ({
    ...state,
    setorDetalhar: action.payload,
  }),
});
